import {
  EmailTemplateEventEnum,
  TranslationLanguageEnum,
} from "helpers/constants";
import { NewEmailTemplate } from "types/emailTemplate.type";
import { z } from "zod";
import { sortByLanguage } from "./EmailTemplateForm.helpers";

export const allowedFileTypes = [
  ".pdf",
  ".doc",
  ".docx",
  ".txt",
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
  ".svg",
  ".gif",
  ".csv",
];

export const allowedMimeTypes = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/svg+xml",
  "image/gif",
  "text/csv",
];

export const EMAIL_TEMPLATE_EVENT_OPTIONS = [
  {
    label: "emailing.templateConfirmation",
    value: EmailTemplateEventEnum.BOOKING_CONFIRMATION,
  },
  {
    label: "emailing.templateCancellation",
    value: EmailTemplateEventEnum.BOOKING_CANCELLATION,
  },
];

export const LANGUAGES_INPUTS = Object.values(TranslationLanguageEnum).sort(
  sortByLanguage,
);

export const DEFAULT_TEMPLATE: NewEmailTemplate = {
  name: "",
  triggerEvent: "",
  includeQrCode: false,
  translations: LANGUAGES_INPUTS.map((languageCode) => ({
    languageCode,
    subject: "content",
    content: "",
  })),
};

export const emailTemplateTranslationSchema = z.object({
  languageCode: z.nativeEnum(TranslationLanguageEnum, {
    errorMap: () => ({ message: "errors.invalid_language" }),
  }),
  subject: z.string().min(5, {
    message: "errors.string_min_5",
  }),
  content: z.string().min(5, {
    message: "errors.string_min_5",
  }),
});

export const emailTemplateAttachmentSchema = z.object({
  name: z.string().optional(),
  base64File: z.string().optional(),
  mimeType: z.string().optional(),
  url: z.string({
    required_error: "errors.invalid_url",
  }),
});

export const emailTemplateSchema = z.object({
  name: z.string().min(5, {
    message: "errors.string_min_5",
  }),
  triggerEvent: z.nativeEnum(EmailTemplateEventEnum, {
    errorMap: () => ({ message: "errors.trigger_event_required" }),
  }),
  includeQrCode: z.boolean().optional(),
  attachments: z
    .array(emailTemplateAttachmentSchema)
    .max(3, { message: "errors.max_attachments" })
    .optional(),
  translations: z
    .array(emailTemplateTranslationSchema)
    .nonempty({ message: "errors.required" }),
});
